import { Select } from 'antd';
import React, { useState } from 'react';
import { OptionType } from '../DropdownGeneral/DropdownGeneral.type';
import styles from './DropdownAutocomplete.module.scss';
import { DropdownAutocompleteProps } from './DropdownAutocomplete.type';
import { useClickOutside } from '@src/Common/Hooks/useClickOutside';

const RemoveIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <mask
      id="mask0_2805_8953"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="19"
      height="18"
    >
      <rect x="0.5" width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2805_8953)">
      <path
        d="M5.3 14.25L4.25 13.2L8.45 9L4.25 4.8L5.3 3.75L9.5 7.95L13.7 3.75L14.75 4.8L10.55 9L14.75 13.2L13.7 14.25L9.5 10.05L5.3 14.25Z"
        fill="#E4E4E4"
      />
    </g>
  </svg>
);

const ArrowDown = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <mask
      id="mask0_2805_18063"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2805_18063)">
      <path
        d="M12 15.3751L6 9.3751L7.4 7.9751L12 12.5751L16.6 7.9751L18 9.3751L12 15.3751Z"
        fill="#E4E4E4"
      />
    </g>
  </svg>
);

const DropdownAutocomplete: React.FC<DropdownAutocompleteProps> = ({
  defaultValue,
  list,
  size,
  onChange,
  placeholder,
  maxTagCount = 0,
  dataTestId,
  ...rest
}) => {
  const [selectedItems, setSelectedItems] = useState<string[]>(
    defaultValue?.filter((v) => v) ?? []
  );

  const [isFocused, setIsFocused] = useState<boolean>(true);

  const filteredOptions = list.filter((o: OptionType) => {
    if (maxTagCount && maxTagCount > 0 && selectedItems.length >= maxTagCount) {
      return false;
    }
    return !selectedItems.includes(o.value);
  });

  const notFoundContent =
    maxTagCount > 0 && selectedItems.length === maxTagCount
      ? `You can only choose maximum number of ${maxTagCount} country`
      : undefined;

  const domNode = useClickOutside(() => {
    setIsFocused(false);
  });

  return (
    <div
      className={styles['area'] + ' ' + (isFocused ? styles['Focused'] : '')}
      data-testid={dataTestId ?? 'dropdown-autocomplete'}
      ref={domNode}
    >
      <Select
        showSearch={false} //disable typing
        maxTagCount={maxTagCount}
        suffixIcon={<ArrowDown />}
        getPopupContainer={(trigger) => trigger.parentNode}
        className={
          styles['Container'] + ' ' + (isFocused ? styles['Focused'] : '')
        }
        mode="multiple"
        notFoundContent={notFoundContent}
        size={size}
        onChange={(v: string[]) => {
          setSelectedItems(v);
          if (onChange) onChange(v);
        }}
        onFocus={(e) => {
          e.preventDefault();
          setIsFocused(true);
        }}
        value={selectedItems}
        options={filteredOptions}
        placeholder={placeholder}
        popupMatchSelectWidth={true}
        removeIcon={<RemoveIcon />}
        virtual={false}
        {...rest}
      />
    </div>
  );
};

export default DropdownAutocomplete;
